import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { JobsRepository } from "../../repositories";


@Injectable({ providedIn: 'root' })
export class PrintJobUsecase implements UseCase<string,HttpResponse<Blob>> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(param:  string): Observable<HttpResponse<Blob>> {
    return this.jobRepository.printJob(param);
  }

}
